<template>
  <div :class="`favouriteBoy container ${dialog ? '':'h-100'}`">
    <div v-if="!dialog" class="content">
      <div class="header">
        <el-form :model="searchCondition" inline size="mini" class="search-form" @submit.native.prevent>
          <el-form-item label="红人昵称">
            <el-input class="input-m" v-model="searchCondition.nickname"
                      placeholder="请输入红人昵称" @change="onSubmit" clearable></el-input>
          </el-form-item>
          <el-form-item label="经纪人">
            <el-input class="input-m" v-model="searchCondition.agent_name"
                      placeholder="请输入经纪人" @change="onSubmit" clearable></el-input>
          </el-form-item>
          <el-form-item label="省/市">
            <el-cascader
                class="input-m"
                size="mini"
                :options="options"
                v-model="selectedOptions"
                @change="handleRegionChange" clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="报价">
            <el-row :gutter="8" class="price-row">
              <el-col :span="8">
                <el-select v-model="searchCondition.price_range" placeholder="请选择报价区间"
                           class="input-full" @change="onSubmit" clearable>
                  <el-option label="最低报价" value="min_price"></el-option>
                  <el-option label="平均报价" value="average_price"></el-option>
                  <el-option label="最高报价" value="max_price"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-input class="input-full" v-model="searchCondition.bottom_price"
                          placeholder="最低报价" @change="onSubmit" clearable></el-input>
              </el-col>
              <el-col :span="8">
                <el-input class="input-full" v-model="searchCondition.top_price"
                          placeholder="最高报价" @change="onSubmit" clearable></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="平台">
            <PlatformSelect @change="changePlatform"></PlatformSelect>
          </el-form-item>
          <el-form-item label="红人标签">
            <el-select v-model="searchCondition.target" placeholder="请选择红人标签" class="input-m"
                       @change="onSubmit" clearable>
              <el-option v-for="target in targets" :key="target" :label="target"
                         :value="targets[target]"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" class="el-button--operation" size="mini" @click="onSubmit">
              搜索
            </el-button>
            <el-button @click="onReset" style="margin-right:0;" size="mini">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" icon="el-icon-download" @click="exportExcel"
                       v-if="userAuth.can_export_artist_info">导出
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="page-main">
        <div class="toolbar">
          <el-button @click="goFBoy" size="mini" icon="el-icon-plus" class="el-button--operation"
                     v-if="userAuth.can_create_artist_info">
            添加红人
          </el-button>
          <el-button size="mini"
                     type="danger"
                     plain
                     icon="el-icon-delete"
                     :disabled="ids.length===0"
                     @click="deleteFBoy(ids)"
                     v-if="userAuth.can_delete_artist_info">批量删除
          </el-button>

        </div>
        <div class="default-table"
             v-loading="tableLoading"
             element-loading-spinner="el-icon-loading"
             element-loading-text="加载中……">

          <el-table :data="tableData" height="100%" style="width: 100%" border stripe
                    @sort-change="sortChange" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
            <el-table-column prop="nickname" label="昵称" width="140" align="center" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="`ID:${scope.row.id}`" placement="right">
                  <el-link type="primary" @click="jumpToDetail(scope.row)">
                    {{ scope.row.nickname }}
                  </el-link>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="platforms[0].platform" label="平台" width="100">
              <template slot-scope="scope">
                <div class="cell-multi" v-for="item in scope.row.platforms" :key="item.id">{{ item.platform }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="platforms[0].uid" label="平台ID" width="120">
              <template slot-scope="scope">
                <div class="cell-multi" v-for="item in scope.row.platforms" :key="item.id">{{ item.uid }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="fans_num" label="粉丝数量" width="100" align="center" sortable="custom">
              <template slot-scope="scope">
                <div class="cell-multi" v-for="item in scope.row.platforms" :key="item.id">{{ item.fans_num }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="platforms[0].rate" label="分成比例" width="80">
              <template slot-scope="scope">
                <div class="cell-multi" v-for="item in scope.row.platforms" :key="item.id">{{ item.rate }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="target" label="红人标签" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="agent_name" label="经纪人" width="80"></el-table-column>
            <el-table-column prop="min_price" label="最低报价" width="100" sortable="custom"></el-table-column>
            <el-table-column prop="average_price" label="平均报价" width="80"></el-table-column>
            <el-table-column prop="max_price" label="最高报价" width="80"></el-table-column>
            <el-table-column prop="platform_bj[0].name" label="报价明细" width="180">
              <template slot-scope="scope">
                <div class="price-item" v-for="item in scope.row.platform_bj" :key="item.id">
                  <span class="price-name">{{ item.name }}：</span>
                  <span class="price-value">{{ $utils.numberFormat(item.price) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="province" label="省" width="80" align="center"></el-table-column>
            <el-table-column prop="city" label="市" width="80" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200" align="left"
                             header-align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="creator.name" label="创建人" width="80" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="created_at" label="创建时间" width="140" align="center"></el-table-column>
            <el-table-column prop="updated_at" label="修改时间" width="140" align="center" sortable="custom"></el-table-column>
            <el-table-column label="操作项" width="200" align="center" fixed="right">
              <template slot-scope="scope">
                <div class="op-box">
                  <el-link class="op-link" type="primary" @click="handleTopFBoy(scope.row)">
                    <span v-if="scope.row.sort > 0">取消置顶</span>
                    <span class="el-icon-top" v-else>置顶</span>
                  </el-link>
                  <el-link class="op-link" type="primary" @click="editFBoy(scope.row)"
                           :disabled="!(userAuth.option_update_artist_info)">
                    <i class="el-icon-edit"></i>编辑
                  </el-link>
                  <el-link class="op-link" type="danger" @click="deleteFBoy([scope.row])"
                           :disabled="!(userAuth.can_delete_artist_info)">
                    <i class="el-icon-delete"></i>删除
                  </el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <div class="pagination-wrap">
          <pagination :total.sync="params.total" :limit.sync="params.per_page" :page.sync="params.page"
                      @pagination="getList"/>
        </div>
        <!-- 红人初始数据来源说明 -->
        <div class="data-source-tip">
          <i class="el-icon-info"></i>
          <span>红人初始数据来源：星象仪系统签约红人，同步红人的基本信息到本系统</span>
        </div>
      </div>

    </div>

  </div>


</template>
<script>
import {CodeToText, provinceAndCityData} from 'element-china-area-data'
import {banchDelete, getFBoyList, topfBoy} from '../../api/fboy'
import {getOptionItems} from '../../api/option'

export default {
  name: 'favouriteBoy',
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableLoading: true,
      //查询条件
      searchCondition: {
        nickname: '', //红人名称
        agent_name: '', //经纪人名称
        provice: '',
        city: '',
        price_range: '', //搜索条件 报价区间
        bottom_price: '', //搜索条件 最低报价
        top_price: '', //搜索条件 最高报价
        platform: '', //搜索条件 平台
        target: '',//搜索条件 红人标签
      },
      params: {
        page: 1,
        per_page: 15,
        total: 0,
      },
      options: provinceAndCityData,
      selectedOptions: [],
      optionsItem: ['platforms', 'targets'],
      platforms: {},
      targets: {},
      // theadData: [],
      // fboyData: [],
      tableData: [],

      sort: {
        order: '',
        prop: ''
      },
      ids: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  activated() {
    this.search()
  },
  created() {
    this.getOptions(this.optionsItem)
    this.getList()
  },
  methods: {
    exportExcel() {
    },
    handleSelectionChange(ids) {
      this.ids = ids
    },
    //删除红人单个
    deleteFBoy(list) {
      if (list.length) {
        let _idList = []
        for (let index = 0; index < list.length; index++) {
          _idList.push(list[index].id)
        }
        let ids = _idList
        let that = this
        that.showModal({
          h: that,
          text: '真的要删除选中行吗？',
          confirm: function () {
            that.handleDelete(ids)
          },
          cancel: function () {
            // eslint-disable-next-line
            console.log('cancel')
          }
        })
      } else {
        this.showToast({
          h: this,
          icon: 'el-icon-warning',
          text: '请选择要删除的数据'
        })
      }
    },
    //批量删除
    handleDelete(ids) {
      // eslint-disable-next-line
      banchDelete(ids).then(res => {
        if (res.success) {
          this.showToast({
            h: this,
            text: '删除成功！'
          })
          this.search()
        }
      })
    },
    //编辑红人
    editFBoy(row) {
      const {href} = this.$router.resolve({
        name: `addFBoy`,
        query: {type: "edit", id: row.id}
      });
      window.open(href, "_blank");
    },
    //置顶
    handleTopFBoy(row) {
      let id = row.id
      let data = {
        id: id
      }
      //sort==0置顶 需要传top
      if (row.sort == 0) {
        data.top = 1
      }
      // eslint-disable-next-line
      topfBoy(data).then(res => {
        this.showToast({h: this})
        this.search()
      })

    },
    setPageChange(val) {
      this.params.page = val
      this.search()
    },
    changePerpage(val) {
      this.params.per_page = val
      this.params.page = 1
      this.search()
    },
    sortChange(e) {
      // 只保留排序字段与方向（ascending/descending），避免把 el-table 的 column 实例带进请求参数
      this.sort = {order: e.order, prop: e.prop}
      this.search()
    },
    getOptions(options) {
      getOptionItems(options).then(res => {
        this.platforms = res.model.platforms || {}
        this.targets = res.model.targets || {}
      })
    },
    handleRegionChange(e) {
      this.searchCondition.provice = CodeToText[e[0]]
      this.searchCondition.city = CodeToText[e[1]]
      this.onSubmit()
    },
    changePlatform(val) {
      this.searchCondition.platform = val
      this.onSubmit()
    },
    onSubmit() {
      this.setPageChange(1)
    },
    handleSearchCondition() {
      let condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field]) {
          condition[field] = this.searchCondition[field]
        }
      })

      // 分页 +排序
      Object.assign(condition, {page: this.params.page, per_page: this.params.per_page}, this.sort)

      return condition
    },
    search() {
      this.params.page = 1
      this.getList()
    },
    //红人列表
    getList() {
      this.tableLoading = true
      const searchCondition = this.handleSearchCondition()
      getFBoyList(searchCondition).then(res => {
        this.tableLoading = false
        let data = res.model.data.data
        this.tableData = data || []
        // this.theadData = res.model.tableCols
        // this.fboyData = res.model.data.data
        this.params.total = res.model.data.total || 100
      })
    },
    onReset() {
      this.searchCondition = {
        nickname: '', //红人名称
        agent_name: '', //经纪人名称
        provice: '',
        city: '',
        price_range: '', //搜索条件 报价区间
        bottom_price: '', //搜索条件 最低报价
        top_price: '', //搜索条件 最高报价
        platform: '', //搜索条件 平台
        target: '',//搜索条件 红人标签
      }
      this.selectedOptions = []
      this.setPageChange(1)
    },
    goFBoy() {
      const {href} = this.$router.resolve({
        name: `addFBoy`,
        query: {type: 'add'}
      });
      window.open(href, "_blank");
    },
    // 回调红人信息
    goSelect(row) {
      this.$emit('rowSelect', row)
    },
    editSearchNickname(val) {
      this.searchCondition.nickname = val
    },
    jumpToDetail(row) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const {href} = this.$router.resolve({
        name: `homeArtistDetail`,
        query: {
          artistId: row.id,
          artistName: row.nickname,
          year: currentYear,
        }
      });
      window.open(href, "_blank");
    },
  }
}
</script>
<style scoped>
/* 页面整体：上下结构（搜索区 / 表格区），表格区自动撑满剩余高度 */
.favouriteBoy {
  display: flex;
  flex-direction: column;
}

.content {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 搜索区 */
.header {
  flex: none;
  background: #fff;
  padding: 12px 16px 0;
  border-radius: 6px;
  border-bottom: 1px solid #F2F2F2;
  margin-bottom: 8px;
}

.search-form ::v-deep .el-form-item {
  margin-right: 16px;
  margin-bottom: 12px;
}

.input-m {
  width: 180px;
}

/* 报价区间：三个控件等宽排列，不再互相挤压 */
.price-row {
  width: 480px;
}

.input-full {
  width: 100%;
}

.price-row ::v-deep .el-col {
  padding-left: 4px;
  padding-right: 4px;
}

/* 表格区 + 分页 */
.page-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 0 2px;
  margin: 0 auto;
}

.toolbar {
  flex: none;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.toolbar ::v-deep .el-button + .el-button {
  margin-left: 8px;
}

.default-table {
  flex: 1;
  min-height: 200px;
}

.pagination-wrap {
  flex: none;
  padding: 6px 2px 0;
}

/* 列表底部：红人初始数据来源说明 */
.data-source-tip {
  flex: none;
  display: flex;
  align-items: center;
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 4px;
  background: #f4f4f5;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.data-source-tip i {
  margin-right: 4px;
  font-size: 14px;
}

/* 单元格内容：多平台信息分行展示 */
.cell-multi {
  overflow: hidden;
  line-height: 18px;
  padding: 1px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cell-multi + .cell-multi {
  border-top: 1px dashed #f0f0f0;
}

.price-item {
  display: flex;
  justify-content: space-between;
  line-height: 18px;
}

.price-item + .price-item {
  margin-top: 2px;
}

.price-item .price-name {
  overflow: hidden;
  color: #606266;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.price-item .price-value {
  flex: none;
  margin-left: 8px;
  color: #303133;
  font-weight: 500;
}

/* 操作列 */
.op-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.op-box .op-link + .op-link {
  margin-left: 10px;
}

::v-deep.default-table tr.el-table__row .cell {
  line-height: 20px !important;
}

::v-deep .default-table tr.el-table__row .cell {
  height: auto !important;
}
</style>
